/**
 * CMCD MIME type for event report payloads.
 *
 * @public
 */
export const CMCD_MIME_TYPE = 'application/cmcd'
